import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { api } from '@/utils';
import { Category } from '@/models/category';
import Form from './components/Form.vue';
import { ref } from 'vue';
import { Substance } from '@/models/substance';
import useQuasar from 'quasar/src/composables/use-quasar.js';;
import { FormulaForm, toRequestData } from './models/formula-form';

interface Props {
  categories: Category[];
  substances: Substance[];
}

interface Emits {
  (e: 'open'): void;
  (e: 'close'): void;
  (e: 'created'): void;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    categories: null,
    substances: null
  },
  emits: ["open", "close", "created"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'open'): void;
  (e: 'close'): void;
  (e: 'created'): void;
}), expose: any, slots: any, attrs: any }) {




const quasar = useQuasar();

const show = ref<boolean>(false);

const form = ref<InstanceType<typeof Form> | null>(null);

const save = (formData: FormulaForm) => {
  api
    .post('formula', { ...toRequestData(formData) })
    .then(() => {
      quasar.notify({
        type: 'positive',
        message: 'Usuário criado com sucesso!',
      });

      close();
      form.value?.resetForm();
      emit('created');
    })
    .catch((error) => {
      if (error.response.status === 422) {
        quasar.notify({
          type: 'warning',
          message: error.response.data.message,
        });
      } else {
        quasar.notify({
          type: 'negative',
          message: error.response.data.message,
        });
        console.log('Erro ao salvar usuário.', error.response);
      }
    });
};

const open = () => {
  show.value = true;
  emit('open');

  setTimeout(() => form.value?.setSubstances(), 250);
};

const close = () => {
  show.value = false;
  emit('close');
};

expose({ open, close });

return (_ctx: any,_cache: any) => {
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: show.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, null, {
        default: _withCtx(() => [
          _createVNode(Form, {
            ref_key: "form",
            ref: form,
            categories: __props.categories,
            substances: __props.substances,
            onSave: save,
            onCancel: close
          }, null, 8, ["categories", "substances"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})